import { useListFilter } from '@jetshop/core/hooks/Filters/useListFilter';
import t from '@jetshop/intl';
import ErrorBoundary from '@jetshop/ui/ErrorBoundary/Generic';
import PassThrough from '@jetshop/ui/ErrorBoundary/PassThrough';
import React from 'react';
import { ListFilterItem } from './ListFilterItem';

export function ListFilters({ filters }) {
  const listFilters = filters.filter(
    (filter) => filter.__typename === 'ListFilter'
  );

  if (listFilters.length === 0) return null;

  return listFilters.map((filter) => (
    <ErrorBoundary component={PassThrough} key={filter.id}>
      <ListFilter filter={filter} />
    </ErrorBoundary>
  ));
}

function ListFilter({ filter }) {
  const { apply, clear } = useListFilter({ filter });

  const sortingItems = [...filter.items];

  return (
    <div className="filter filter-list">
      <h4 className={`title`}>
        <span className="filter-name title">{filter.name}</span>
      </h4>
      <ul className="filter-items">
        {sortingItems.map((item, index) => (
          <li key={index}>
            <button
              key={item.id}
              onClick={() => {
                if (item.resultCount > 0) {
                  apply({ value: item.value });
                }
              }}
              style={
                item.resultCount === 0
                  ? {
                      opacity: 0.4,
                      cursor: 'not-allowed',
                    }
                  : {}
              }
            >
              <ListFilterItem item={item} name={filter.name} />
            </button>
          </li>
        ))}
        <>
          {filter.hasActiveItems && (
            <li>
              <button
                className="clear-dropdown"
                onClick={() => {
                  clear();
                }}
              >
                {t('Clear filter')}
              </button>
            </li>
          )}
        </>
      </ul>
    </div>
  );
}
